import LeaderboardPage from './leaderboard-page'
import LeaderboardPageWithData from './leaderboard-page.query'
import { leaderboardFragment } from './leaderboard-fragment'

export {
  LeaderboardPageWithData,
  leaderboardFragment,
}

export default LeaderboardPage
